export default "__VITE_ASSET__BnJdBQ6n__"